import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/modifications/useModificationQueryKeys.ts
var t = e("booking-modifications", {
	list: (e) => ["list", e],
	myList: (e) => ["my-list", e],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as modificationQueryKeys };
